import { combineReducers } from 'redux';
import { get, isEqual, unionWith } from 'lodash';

import {
    CREATE_SESSION_FAILURE,
    CREATE_SESSION_SUCCESS,
    LOGIN_FAILURE,
    SKIP_VALIDATION,
    VALIDATE_SESSION_FAILURE,
    VALIDATE_SESSION_SUCCESS,
} from '../actions/types/authentication-action-types';
import {
    FETCH_FEATURE_FLAG_SUCCESS,
    SWITCH_REPORT_TABS,
    SWITCH_SIDE_NAV_ITEMS,
    CLOSE_RIGHT_PANE,
} from '../actions/types/ui-state-action-types';
import {
    OPEN_COLLECTION_TAB,
    SWITCH_COLLECTION_TABS
} from '../../dashboard/actions/types/collection-action-types';
import { OPEN_RIGHT_PANE } from '../actions/types/right-pane-action-types';

import { COLLECTION_SUCCESS } from '../../dashboard/actions/types/dashboard-action-types';

import { isExperimentalMode } from '../../utils/environmental-utils';
import { REPORTS_NAV_ITEM } from '../constants/ui-options';
import { SAVE_CANVAS_SETTINGS } from '../../dashboard/actions/types/canvas-action-types';

// Login
function loginError( state = false, action ){
    let newState;
    switch( action.type ){
        case LOGIN_FAILURE:
            newState = true;
            break;
        default:
            return state;
    }

    return newState;
}

function loginStatus( state = null, action ){
    let newState;
    switch( action.type ){
        case LOGIN_FAILURE:
            newState = get( action, 'error.status', false );
            break;
        default:
            return state;
    }

    return newState;
}

function isInitialLoad( state = true, action ){
    let newState;
    switch( action.type ){
        case SKIP_VALIDATION:
        case VALIDATE_SESSION_SUCCESS:
        case CREATE_SESSION_SUCCESS:
        case CREATE_SESSION_FAILURE:
        case VALIDATE_SESSION_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}


// Reports
const initialReportsState = {
    reportTabIndex: 0,
};

function reports( state = initialReportsState, action ){
    let newState;

    switch( action.type ){
        case SWITCH_REPORT_TABS:
            newState = { ...state, reportTabIndex: action.selectedTabIndex };
            break;
        default:
            return state;
    }

    return newState;
}


// Navigation
const initialExperimentalFlag = isExperimentalMode() || false;
const initialNavState = [ REPORTS_NAV_ITEM ];

function isExperimental( state = initialExperimentalFlag ){
    return state;
};

function sideNavItems( state = initialNavState, action ){
    let newState;

    switch( action.type ){
        case COLLECTION_SUCCESS:
            let dynamicItems =  action.payload.result.collections.map( id => {
                const col = action.payload.entities.collections[id];

                return {
                    base: '/collections',
                    exportable: col.exportable,
                    icon: col.icon,
                    id: col.id,
                    isExperimental: true,
                    label: col.name,
                    order: col.order,
                    url: `/${col.id}`,
                };
            } );
            newState = [
                ...state,
                ...dynamicItems
            ];
            break;
        default:
            newState = state;
    }
    return newState;
}

function selectedSideNavId( state = null, action ){
    let newState;
    switch( action.type ){
        case SWITCH_SIDE_NAV_ITEMS:
            newState = action.selectedItemId;
            break;
        default:
            newState = state;
    }

    return newState;
}


// Workspaces
/* Array of previously opened canvas tabs on a given collection page */
function collectionTabItems( state = [], action ){
    let newState = state;

    switch( action.type ){
        case OPEN_COLLECTION_TAB:
            // If overview tab isn't already present (e.g, user accesses canvas via url),
            // we need to add it
            if( action.parentTab && state.length === 0 ){
                newState = [
                    {
                        id: action.parentTab.id,
                        name: action.parentTab.name,
                        url: action.parentTab.url
                    }
                ];
            }

            const newTabItem = {
                id: action.selectedTab.id,
                name: action.selectedTab.name,
                url: action.selectedTab.url
            };

            // Append new tab item if it doesn't already exist in current collection
            newState = unionWith( newState, [newTabItem], isEqual );

            break;
        case SWITCH_SIDE_NAV_ITEMS:
            // Switch nav items should only reset collection tab items if you're hitting a collection for the first time
            // or if you're switching collections
            if( newState.length === 0 || newState[0].id !== action.selectedItemId ){
                newState = [
                    {
                        id: action.selectedItemId,
                        name: action.selectedItemName,
                        url: action.selectedItemUrl,
                    }
                ];
            }

            break;
        default:
            newState = state;
    }
    return newState;
}

/* Currently selected canvas tab on the current collection */
function selectedCollectionTabId( state = null, action ){
    let newState = state;

    switch( action.type ){
        case SWITCH_COLLECTION_TABS:
            newState = action.selectedTabId;
            break;
        default:
            newState = state;
    }

    return newState;
}

function featureFlags( state = { maintenance: false }, action ){
    if( action.type === FETCH_FEATURE_FLAG_SUCCESS ){
        return action.featureFlags;
    }
    else{
        return state;
    }
}

function isEditMode( state = false, action ){
    let newState;
    switch( action.type ){
        case OPEN_RIGHT_PANE:
            newState = action.activeRightPane === 'canvasSettings';
            break;
        case CLOSE_RIGHT_PANE:
        case SWITCH_COLLECTION_TABS:
        case SWITCH_SIDE_NAV_ITEMS:
        case SAVE_CANVAS_SETTINGS:
            newState = false;
            break;
        default:
            newState = state;
    }

    return newState;
}

export default combineReducers( {
    collectionTabItems,
    featureFlags,
    isEditMode,
    isExperimental,
    isInitialLoad,
    loginError,
    loginStatus,
    reports,
    selectedCollectionTabId,
    selectedSideNavId,
    sideNavItems,
} );
